const TESTIMONIALS = [
  {
    name: 'Marcus T.',
    role: 'Student Pilot · 62 hrs',
    avatar: 'https://public.readdy.ai/ai/img_res/4e7af61d1f84b5e992b7b8a0ae04ee96.jpg',
    quote: 'The ATC transcription alone is worth it. I used to panic on the radio — now I can review every exchange after the flight and actually learn from it.',
    stars: 5,
  },
  {
    name: 'Sarah K.',
    role: 'PPL · 210 hrs',
    avatar: 'https://readdy.ai/api/search-image?query=female%20pilot%20headshot%20professional%20photo%20neutral%20background%20confident%20smile%20aviation%20uniform%20realistic%20portrait%20photography%20high%20quality&width=80&height=80&seq=ea-avatar-02&orientation=squarish',
    quote: 'My CFI noticed a huge improvement in my pattern work after just 3 weeks. The visual analysis showed me exactly where I was drifting on final.',
    stars: 5,
  },
  {
    name: 'James R.',
    role: 'CFI · 1,400 hrs',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20male%20flight%20instructor%20headshot%20professional%20photo%20neutral%20background%20confident%20smile%20aviation%20uniform%20realistic%20portrait%20photography%20high%20quality&width=80&height=80&seq=ea-avatar-03&orientation=squarish',
    quote: "I recommend WingmanFix to all my students. The post-flight debrief saves me 20 minutes per lesson — the AI catches things I'd normally have to replay from memory.",
    stars: 5,
  },
  {
    name: 'Priya M.',
    role: 'IFR Student · 145 hrs',
    avatar: 'https://readdy.ai/api/search-image?query=south%20asian%20female%20pilot%20headshot%20professional%20photo%20neutral%20background%20confident%20smile%20aviation%20uniform%20realistic%20portrait%20photography%20high%20quality&width=80&height=80&seq=ea-avatar-04&orientation=squarish',
    quote: 'Studying for my instrument rating felt overwhelming until WingmanFix. The missed clearance alerts during sim sessions are a game changer.',
    stars: 5,
  },
];

const LOGOS = [
  { name: 'AOPA', icon: 'ri-plane-line' },
  { name: 'EAA', icon: 'ri-flight-takeoff-line' },
  { name: 'NAFI', icon: 'ri-award-line' },
  { name: 'FAA Safety', icon: 'ri-shield-star-line' },
  { name: 'ForeFlight', icon: 'ri-map-2-line' },
];

export default function EarlyAccessSocialProof() {
  return (
    <section className="py-24 px-6 bg-[#0A1628]">
      <div className="max-w-6xl mx-auto">
        {/* Trusted by */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-6">
            Trusted by pilots from communities including
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8">
            {LOGOS.map((l) => (
              <div
                key={l.name}
                className="flex items-center gap-2 text-gray-500 hover:text-gray-300 transition-colors"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${l.icon} text-base`} />
                </div>
                <span className="text-sm font-semibold tracking-wide">{l.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mb-16" />

        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-bold text-[#00FFD1] uppercase tracking-widest mb-3">Beta Feedback</p>
          <h2 className="text-4xl font-extrabold mb-4">
            Pilots love it. <span className="text-[#00FFD1]">Here's why.</span>
          </h2>
          <p className="text-gray-400 text-base max-w-lg mx-auto">
            Real feedback from our closed beta testers — unfiltered and unsponsored.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className="bg-white/4 border border-white/10 rounded-2xl p-7 hover:border-[#00FFD1]/30 transition-all duration-300 group"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#00FFD1] text-sm" />
                  </div>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden border border-white/20 flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="text-sm font-bold text-white">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.role}</div>
                </div>
                <div className="ml-auto w-8 h-8 flex items-center justify-center">
                  <i className="ri-double-quotes-r text-[#00FFD1]/30 text-2xl group-hover:text-[#00FFD1]/60 transition-colors" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom stat bar */}
        <div className="mt-12 grid grid-cols-3 gap-4">
          {[
            { value: '4.9/5', label: 'Average beta rating', icon: 'ri-star-fill' },
            { value: '94%', label: 'Would recommend', icon: 'ri-thumb-up-line' },
            { value: '3×', label: 'Faster skill progression', icon: 'ri-speed-up-line' },
          ].map((s) => (
            <div
              key={s.label}
              className="bg-white/4 border border-white/10 rounded-xl py-5 px-4 text-center"
            >
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${s.icon} text-[#00FFD1] text-base`} />
                </div>
                <span className="text-2xl font-extrabold text-white">{s.value}</span>
              </div>
              <p className="text-xs text-gray-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
